<kendo-tabstrip [tabscroll]="false" [keepTabContent]="true" [animate]="true" #tabstrip class="flex-fill">

  <!--  Tab 1 begin  Static Tab     -->
  <kendo-tabstrip-tab [selected]="true">
    <ng-template kendoTabTitle>
      Summary<span class="k-icon k-font-icon k-icon-20"></span>
    </ng-template>
    <ng-template kendoTabContent>
      <app-project-estimate-summary
        [iProjectId]="projectTab().ProjectId"
        [Project]="projectTab().Project"
        [iProjectTypeId]="projectTab().ProjectTypeId"
        [iProjectStatusId]="projectTab().ProjectStatusId"
        (projectEstimateState)="readProjectEstimateState($event)"
        (closeDraftTab)="closeDraftTab()">
      </app-project-estimate-summary>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [disabled]="disableAllEdits" class="flex-column">
    <ng-template kendoTabTitle>
      Items<span class="k-icon k-font-icon k-icon-20"></span>
    </ng-template>
    <ng-template kendoTabContent>
      <app-project-resources class="flex-column flex-fill flex-100"
        [projectTab]="this.projectTab()" #AppProjectResources>
      </app-project-resources>
    </ng-template>
  </kendo-tabstrip-tab>
  <!--  tab 1 end       -->

  <!-- || tabstrip 2, dynamic tabs begin ||      -->
  @for (tabItem of tabItems; track tabItem; let i=$index) {
  <kendo-tabstrip-tab class="flex-column">
    <ng-template kendoTabTitle>
      <div class="estimate-tab">
        {{tabItem.TabTitle}}
        <div class="estimate-tab--close" (click)="closeTab(i,tabItem)">
          <i class="material-icons">clear</i>
        </div>
      </div>
    </ng-template>
    <ng-template kendoTabContent>
      <app-project-estimate-detail class="flex-column flex-fill flex-100"
        [(estimateStatusId)]="tabItem.ProjectEstimate.ProjectEstimateStatusId"
        [iProjectId]="projectTab().ProjectId"
        [iProjectTypeId]="projectTab().ProjectTypeId"
        [iProjectStatusId]="projectTab().ProjectStatusId"
        [iProjectEstimateId]="tabItem.ProjectEstimateId"
        [projectEstimateState]="estimateState"
        [iRecordTypeId]="tabItem.RecordTypeId"
        (dialogClosed)="reloadEstimatesSummary()">
      </app-project-estimate-detail>
    </ng-template>
  </kendo-tabstrip-tab>
  }
</kendo-tabstrip>